import { rootStore } from 'store/root';
import { exec } from 'service/nxl-protocol';
import { initSession, logout } from 'service/session-api';
import history from 'service/history';
import { sleep } from 'service/utils';

const {
    win,
    nxlApi,
    location,
    electron: { show_window, open_window },
} = window;

export default nxlApi.frontEnd.sub((key: string, data: any) => {
    // for all windows
    switch (key) {
        case 'window':
            if (data.target === win.name) {
                switch (data.command) {
                    case 'reload':
                        window.location.reload();
                        break;
                    default: {
                        const browserWindow: any = win;
                        browserWindow[data.command]();
                    }
                }
            }
            break;
        case 'library':
            rootStore.appStore.fetchLibrary();
            break;
        case 'changeFEVersion':
            location.href = `${location.pathname}?index_tag=${data}`;
            break;
        case 'setStreamingInGame':
            rootStore.appStore.library.find((x) => x.productId === data.productId)?.setStreamingInGame(data.value);
            break;
        default:
    }

    // only for main window
    if (win.name === 'main') {
        switch (key) {
            case 'logout':
                logout();
                break;
            case 'processNxlUrl':
                if (win.stateName === 'login') {
                    sessionStorage.setItem('nxlProtocol', data); // temporary storage
                } else {
                    exec(data);
                }
                break;
            case 'initSession':
                initSession(data);
                break;
            case 'playGame':
                (async (d: any) => {
                    const { productId } = d;

                    rootStore.session.setLastPlayedGame(productId); // shortcut

                    nxlApi.frontEnd.pub('openPage', productId);
                    for (let n = 0; n < 10; n++) {
                        await sleep(500);
                        if (rootStore.appStore.nextAction(productId.toString())) break;
                    }
                })(data);
                break;
            case 'openPage':
                {
                    const id = parseInt(data, 10);
                    if (id > 10000 || id === 201) {
                        rootStore.dialogs.closeAll();
                        if (id > 10000 && rootStore.appStore.library.find((x) => parseInt(x.productId, 10) === id)) {
                            history.push(`/main/games/${id}`);
                        } else {
                            // 201 - all games
                            history.push('/main/games/all');
                        }
                        show_window();
                        return;
                    }
                    switch (id) {
                        case 203: // activate from tray menu
                            rootStore.dialogs.open('keyRedemption');
                            show_window();
                            break;
                        case 206:
                            open_window('settings', { initRoute: '/general' });
                            break;
                        case 209:
                            open_window('settings', { initRoute: '/about' });
                            break;
                        case 210:
                            history.push('/main/web/account-settings');
                            show_window();
                            break;
                    }
                }
                break;
            case 'activate':
                show_window();
                rootStore.dialogs.open('keyRedemption');
                break;
            case 'warnLowDiskSpace':
                {
                    const { productID } = data;
                    if (productID) history.push(`/main/games/${productID}`);
                    rootStore.dialogs.error({ title: 'common:notice', message: 'not-enough-space' });
                }
                break;
            case 'notificationEventsUpdate':
                rootStore.notificationCenter.eventSession.fetch();
                break;
            default:
        }
    }
});
